const events = {};

function set(name, value) {
  events[name] = value;
}

function get(name) {
  if (name) {
    const cb = events[name];
    if (cb) {
      return cb;
    }
  }
  return null;
}

export default { set, get };